"use client";

import { SLDialog } from "@/components/dialogs/SLDialog";
import { SLHtmlFromLangFile } from "@/components/sections/home/SLHtmlFromLangFile";
import { useMessages } from "@/lib/i18n/useMessages";
import { Help } from "@mui/icons-material";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { useBooleanState } from "@nvon/react-toolbox";

export const RVORechnerExplanationButton = ({
  title,
  explanation,
  isPositionRelative,
  size = "small",
}: {
  title: string;
  explanation: string;
  isPositionRelative?: boolean;
  size?: "small" | "medium" | "large";
}) => {
  const {
    state: isDialogueExplanationVisible,
    on: showDialogueExplanation,
    off: hideDialogueExplanation,
  } = useBooleanState(false);
  const { calculator } = useMessages();
  const explanationAriaLabel = calculator.abfindung.showExplanationAria;

  return (
    <Box
      sx={{
        position: isPositionRelative ? "relative" : "absolute",
        right: isPositionRelative ? 0 : 20,
        top: isPositionRelative ? 0 : 20,
      }}
    >
      <Tooltip title={explanationAriaLabel}>
        <IconButton
          onClick={showDialogueExplanation}
          size={size}
          aria-label={explanationAriaLabel}
        >
          <Help
            sx={{ color: (th) => th.palette.primary.main }}
            aria-hidden="true"
          />
        </IconButton>
      </Tooltip>

      <SLDialog
        onClose={hideDialogueExplanation}
        title={title}
        open={isDialogueExplanationVisible}
        content={
          <Typography>
            <SLHtmlFromLangFile htmlString={explanation} />
          </Typography>
        }
      />
    </Box>
  );
};
